export default __webpack_public_path__ + "static/media/bing_aerial_labels.ac17f796.png";